import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCurrencyPoundCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1Zm-1.105 7.956c.002-.538.158-.838.323-1.017.178-.192.452-.337.826-.403.808-.141 1.695.147 2.06.493a1 1 0 1 0 1.377-1.45c-.898-.853-2.458-1.245-3.783-1.012-.693.121-1.406.427-1.95 1.016-.555.602-.852 1.412-.853 2.379v.013c.013 1.008.388 1.7.663 2.208l.017.033c.055.102.105.195.15.284H9a1 1 0 1 0 0 2h.898c-.152.761-.454 1.466-.774 2.046a8.82 8.82 0 0 1-.813 1.22l-.05.06-.01.011v.001A1 1 0 0 0 9 18.5h6a1 1 0 1 0 0-2h-4.118c.426-.774.873-1.814 1.045-3H14a1 1 0 1 0 0-2h-2.132c-.133-.496-.345-.887-.517-1.206l-.016-.03c-.27-.5-.432-.817-.44-1.308Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgCurrencyPoundCircle.displayName = 'CurrencyPoundCircle';
export default SvgCurrencyPoundCircle;
